import React from 'react';
import PropTypes from 'prop-types';
import TdWebService from '../service/TdWebService';
import { withTranslation } from 'react-i18next';

class TdLink extends React.Component {

  static propTypes = {
    t: PropTypes.any.isRequired,
    className: PropTypes.string,
    href: PropTypes.string,
    action: PropTypes.string,
    anchorText: PropTypes.string,
    anchorMessageId: PropTypes.string,
    anchorMessageValue: PropTypes.object,
    openOnNewTab: PropTypes.bool,
    onClick: PropTypes.func,
  };

  onClick(e) {
    //e.preventDefault();
    //e.stopPropagation();

    let {
      action,
      href,
      anchorText,
      anchorMessageId,
      anchorMessageValue,
      t,
    } = this.props;

    let _anchorText = anchorText;
    if (anchorMessageId) {
      _anchorText = t(anchorMessageId, anchorMessageValue);
    }

    return TdWebService.userMenu(action, href, _anchorText)
      .then(() => {
        //window.location.href = href;
        if (this.props.onClick && !href) {
          this.props.onClick();
        }
      })

  }

  render() {

    let {
      className,
      href,
      openOnNewTab,
    } = this.props;

    return (
      <a className={className} onClick={::this.onClick} target={openOnNewTab?'_blank':'_self'} href={href}>
        {this.props.children}
      </a>
    )
  }

}

export default withTranslation()(TdLink)
